import { useVuelidate } from '@vuelidate/core';

var ValidateEach = {
  name: 'ValidateEach',
  props: {
    rules: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },

  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const v = useVuelidate(props.rules, props.state, props.options);
    return () => slots.default({
      v: v.value
    });
  }

};

export { ValidateEach };
